/**
 * Helper d'inférence pour `watchStores` du `FeatureManifest`.
 *
 * @remarks
 * Sans ce helper, l'inférence du selector échoue à cause du widening de
 * l'union `WatchStoreEntry<any>[]` au niveau du tableau (le générique tombe à
 * `unknown` à la définition).
 */

import type { StoreApi, UseBoundStore } from 'zustand';
import type { WatchStoreEntry } from './types';

/**
 * Construit une entrée `watchStores` typée. Préserve le type d'état du store
 * dans le selector — l'auto-complétion et la vérif statique fonctionnent.
 *
 * @example
 * ```ts
 * watchStores: [
 *   watchStoreEntry(useTechTestsStore, (s) => s.selectedEvaluationId),
 * ],
 * ```
 */
export function watchStoreEntry<TState>(
  store: UseBoundStore<StoreApi<TState>>,
  selector: (state: TState) => unknown,
): WatchStoreEntry<TState> {
  return { store, selector };
}
